import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  TimeScale,
  TimeSeriesScale,
  Title,
  Tooltip,
} from 'chart.js';
import 'chartjs-adapter-moment';

export const registerChartJsComponents = () => {
  ChartJS.register(
    ArcElement,
    BarElement,
    CategoryScale,
    Legend,
    LinearScale,
    LineElement,
    PointElement,
    TimeScale,
    TimeSeriesScale,
    Title,
    Tooltip,
    Filler,
  );
  ChartJS.register([tracer]);
};

Tooltip.positioners.custom = function (elements, eventPosition) {
  const tooltip = this;
  const chartArea = tooltip.chart.chartArea;

  return {
    x: eventPosition.x,
    y: (chartArea.bottom - chartArea.top) / 2,
  };
};

export const tracer = {
  id: 'tracer',
  defaults: {
    width: 1,
    color: '#000000',
    style: 'dashed',
    dash: [3, 3],
    groups: {},
    groupId: 0,
    group: [],
  },
  beforeInit: (chart) => {
    chart.tracer = {
      x: 0,
    };
  },
  afterEvent: (chart, args) => {
    const { inChartArea } = args;
    const { x } = args.event;

    chart.tracer = { x, draw: inChartArea };
    chart.draw();
  },
  afterDatasetsDraw: (chart, args, opts) => {
    const { ctx } = chart;
    const { top, bottom } = chart.chartArea;
    if (!chart.tracer) {
      return;
    }
    const { x, draw } = chart.tracer;
    if (!draw) {
      return;
    }

    ctx.save();

    ctx.beginPath();
    ctx.lineWidth = opts.width;
    ctx.strokeStyle = opts.color;
    if (opts.style === 'dashed') {
      ctx.setLineDash(opts.dash);
    }
    ctx.moveTo(x, bottom);
    ctx.lineTo(x, top);
    ctx.stroke();

    ctx.restore();
  },
};

export function setTooltipAtIndex(chart, index) {
  const tooltip = chart.tooltip;

  if (index === undefined) {
    chart.setActiveElements([]);
    tooltip.setActiveElements([], {
      x: tooltip.getActiveElements()?.[0]?.element.x ?? tooltip.x,
      y: 0,
    });
  } else {
    const activeElements = chart.getSortedVisibleDatasetMetas().map((meta) => ({
      datasetIndex: meta.index,
      index: Math.min(index, meta.data.length - 1),
    }));

    chart.setActiveElements(activeElements);
    tooltip.setActiveElements(
      activeElements,
      {
        x: chart.tracer.x,
        y: 0,
      },
    );
  }
}
